import { isNil } from 'lodash';
import { useEffect } from 'react';
import { View } from '@shared/components/View';
import { MBLoadingIndicator } from '@shared/components/loading';
import { MBCardDetails } from '@shared/scenes/cards/details/containers';
import { MBCardDetailsOptionsButton } from '@shared/scenes/cards/details/containers/optionsButton';
import { useChannel, useCurrentBusinessId } from '@shared/util/hooks';
import { MBSentry } from '@shared/util/sentry';

interface Props {
  channelId: number;
  cardId: string;
  templateSlug?: string;
}

export function CardDetails({ channelId, cardId, templateSlug }: Props) {
  const businessId = useCurrentBusinessId();
  const channel = useChannel({ channelId });

  useEffect(() => {
    if (!import.meta.env.PROD || isNil(channel)) {
      return;
    }
    const channelSlug = channel.slug;
    MBSentry.breadcrumb({
      message: 'Low-code external form data',
      category: 'low-code-view',
      data: {
        mode: 'public-card',
        channelSlug,
        channelId,
        businessId,
        cardId,
        templateSlug: templateSlug ?? null,
      },
    });
    MBSentry.message(`External low-code public card rendered`);
  }, [businessId, channel, channelId, templateSlug, cardId]);

  if (isNil(channel)) {
    return <MBLoadingIndicator fill center />;
  }
  return (
    <View fill>
      <MBCardDetailsOptionsButton
        channelSlug={channel.slug}
        cardId={cardId}
        style={{ alignSelf: 'flex-end' }}
        hiddenCardOptions={[
          'edit',
          'duplicate',
          'share',
          'cardHistory',
          'print',
          'selectMultiple',
          'delete',
          'bulkUpdate',
        ]}
      />
      <MBCardDetails channelSlug={channel.slug} cardId={cardId} templateSlug={templateSlug} />
    </View>
  );
}
